import React from "react";

/**
 * Truthful empty-state block. Every module must render this rather than a
 * decorative "coming soon" — see V3 §0 truthful-states rule.
 * @param {Object} props
 * @param {React.ReactNode} [props.icon]
 * @param {string} props.title
 * @param {React.ReactNode} [props.hint]
 */
export function EmptyState({ icon, title, hint }) {
  return (
    <div className="ds-state">
      {icon && <div className="ds-state-icon">{icon}</div>}
      <div className="ds-state-title">{title}</div>
      {hint && <div className="ds-state-hint">{hint}</div>}
    </div>
  );
}
